import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';
import { DataGrid, GridColDef, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import {LocationDto, PrizeDto} from 'src/util/types';

import axios from 'axios';
import config from 'src/config';
import { useAuth } from 'src/util/authenticationProvider';
import { CheckCircle } from '@mui/icons-material';
import { t } from 'i18next';

const formatDate = (value) => {
  return new Date(value).toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};


const columns: GridColDef<any>[] = [
  {
    field: 'participationDate',
    headerName: t('participation.date'),
    width: 170,
    valueFormatter: value =>
      formatDate(value),
  },
  {
    field: 'luckyNumber',
    headerName: t('participation.luckyNumber'),
    width: 150,
  },
  {
    field: 'name',
    headerName: t('participation.name'),
    width: 200,
  },
  {
    field: 'phone',
    headerName: t('participation.phone'),
    width: 200,
  },
  {
    field: 'email',
    headerName: t('participation.email'),
    width: 250,
  },
  {
    field: 'location',
    headerName: t('participation.location'),
    width: 180,
    valueGetter: (location: LocationDto) => {
      return location.name || '';
    },
  },
  {
    field: 'winner',
    headerName: t('participation.win'),
    width: 90,
    type: 'boolean',
    sortable: true,
    // interne Wahrheit für Filter/Sort
    valueGetter: (params: any) => params,
    // Anzeige liest denselben internen Wert
    renderCell: (params: any) =>
        params.row.winner ? <CheckCircle color="success"/> : null
  },
  {
    field: 'wonItem',
    headerName: t('participation.prizes'),
    width: 250,
    valueGetter: (row: PrizeDto) => {
      return `${row ? row.description : ''}`;
    },
  },
  {
    field: 'lotteryName',
    headerName: t('participation.lottery'),
    width: 200,
  },
  {
    field: 'redeemed',
    headerName: t('participation.redeemed'),
    width: 100,
    type: 'boolean',
    valueGetter: (params: any) => params,
    renderCell: (params: any) =>
        params?.row?.redeemed ? <CheckCircle color="success" /> : ''
  }
];

export default function ParticipationHistory() {
 
  const [participants, setParticipants] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [totalParticipants, setTotalParticipants] = useState<number>(0);
  const authContext = useAuth();

  useEffect(() => {
    setLoading(true);
    axios.get(config.apiUrl + `/api/lottery/all/participants/paged?page=${paginationModel.page}&size=${paginationModel.pageSize}`, {
      headers: {
        'Authorization': 'Bearer ' + (authContext.tokens?.accessToken ?? '')
      }
    })
      .then(response => {
        setParticipants(response.data.content.content); // Page is in content.content
        setTotalParticipants(response.data.content.totalElements);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.log(err)
      });
  }, [authContext.tokens?.accessToken, paginationModel.page, paginationModel.pageSize]);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  return (
    <Box sx={{ width: '100%', backgroundColor: '#fff' }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 240 }}>
          <CircularProgress />
        </Box>
      ) : (
        <DataGrid
          rows={participants}
          columns={columns}
          slots={{
            toolbar: CustomToolbar,
          }}
          rowCount={totalParticipants}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          paginationMode="server"
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10, 20, 100]}
          disableMultipleRowSelection
          disableRowSelectionOnClick
        />
      )}
    </Box>
  );
}
